module.exports = __webpack_public_path__ + "img/client.8e1a28cd.svg";